import { derived, writable, type Readable, type Writable } from 'svelte/store';
import type {
	MysteryOrbs,
	PolyPoints,
	Season,
	SeasonIdentifiers,
	UserActivity,
	UserSeasonData
} from '$lib/types/tradingRewards';
import { currentSeason } from './tradingRewardsConfig';
import type { CompetitionConfig } from '$lib/types/leaderboard';
import persistentStorage from '$lib/persistentStorage';

export const loadingSelectedSeason: Writable<boolean> = writable(false);
export const seasons: Writable<Record<SeasonIdentifiers | any, Season | never>> = persistentStorage(
	'season',
	{}
);
export const selectedSeasonIdentifier: Writable<SeasonIdentifiers> = writable(currentSeason);
export const selectedSeason: Readable<Season | undefined> = derived(
	[seasons, selectedSeasonIdentifier],
	([$seasons, $selectedSeasonIdentifier]) => {
		if (
			$seasons &&
			$seasons.hasOwnProperty($selectedSeasonIdentifier) &&
			$selectedSeasonIdentifier
		) {
			return $seasons[$selectedSeasonIdentifier];
		} else {
			return undefined;
		}
	}
);
export const currentSeasonObject: Readable<Season | undefined> = derived(
	[seasons],
	([$seasons]) => {
		if ($seasons && $seasons.hasOwnProperty(currentSeason)) {
			return $seasons[currentSeason];
		} else {
			return undefined;
		}
	}
);

export const loadingUserSeasonStats: Writable<boolean> = writable(true);
export const userSeasonStats: Writable<UserSeasonData | undefined> = persistentStorage(
	'user-season-data',
	undefined
);

export const loadingUserPolyPoints: Writable<boolean> = writable(true);
export const userPolyPoints: Writable<PolyPoints | undefined> = persistentStorage(
	'user-poly-points',
	undefined
);

export const loadingUserMysteryOrbs: Writable<boolean> = writable(true);
export const userMysteryOrbs: Writable<MysteryOrbs[]> = writable([]);

export const loadingUserActivity: Writable<boolean> = writable(true);
export const userActivity: Writable<UserActivity[]> = writable([]);

export const orbToOpenInModal: Writable<string> = writable();
export const levelClaimedInModal: Writable<number> = writable(0);

export const allCompetitions: Writable<CompetitionConfig[]> = writable([]);
export const loadingAllCompetitions: Writable<boolean> = writable(false);

export const currentUserLevel: Writable<Record<string, number>> = persistentStorage(
	'currentUserLevel',
	{}
);

export const isFirstOrbClaimed: Readable<boolean> = derived(
	[userMysteryOrbs],
	([$userMysteryOrbs]) => {
		const orbsClaimed = $userMysteryOrbs.filter((orb) => orb.claimedAt);
		if (orbsClaimed.length) return true;
		return false;
	}
);

export const firstUnclaimedOrb: Readable<MysteryOrbs | undefined> = derived(
	[userMysteryOrbs],
	([$userMysteryOrbs]) => {
		const unclaimedOrb = $userMysteryOrbs.find((orb) => !orb.claimableAfter);
		return unclaimedOrb;
	}
);

export const isUserEligibleForNewYearOrb: Writable<{
	eligible: boolean;
	tier?: string | null;
}> = writable({
	eligible: false
});
